import Component from '@glimmer/component'
import { CalendarIcon } from 'teacher-ui-client/components/calendar-icon'
import { getCellValue, type CustomCellSignature } from 'teacher-ui-client/components/stable-table/basic-table/cell'

function isCalendarItem(value: unknown): value is { month: string; day: string } {
  return Boolean(
    value &&
    typeof value === 'object' &&
    'month' in value &&
    typeof value.month === 'string' &&
    'day' in value &&
    typeof value.day === 'string',
  )
}

export class CalendarIconCell extends Component<CustomCellSignature> {
  get value() {
    const value = getCellValue(this.args.tableMeta)
    return isCalendarItem(value) ? value : { month: '-', day: '-' }
  }

  <template><CalendarIcon @month={{this.value.month}} @day={{this.value.day}} ...attributes /></template>
}

export default CalendarIconCell
